// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixWindow from 'wix-window';
//  import { session } from 'wix-storage';
//  import wixLocation from 'wix-location';


$w.onReady(function () {
// 	 let path = wixLocation.path;
// 	 let currentPage = path[0];
// 	 console.log(path[0]);
// 	 if (currentPage !== "product-page") {
// 	 	session.setItem("page", wixLocation.url);
// 		console.log("I'm Here");
// }

	if (wixWindow.formFactor === "Mobile") {

		$w("#logosmobile").show();

	}

});

export function anchorheader_viewportEnter(event, $w) {
	$w("#logosmall").hide();
	$w("#biglogo").show();

}
export function anchorheader_viewportLeave(event, $w) {
	$w("#logosmall").show();
	$w("#biglogo").hide();
}